/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestAllExcelDownloadUrl
 */
export interface RequestAllExcelDownloadUrl {
    /**
     * 
     * @type {Array<any>}
     * @memberof RequestAllExcelDownloadUrl
     */
    stations: Array<any>;
    /**
     * 
     * @type {number}
     * @memberof RequestAllExcelDownloadUrl
     */
    part?: number;
}

/**
 * Check if a given object implements the RequestAllExcelDownloadUrl interface.
 */
export function instanceOfRequestAllExcelDownloadUrl(value: object): value is RequestAllExcelDownloadUrl {
    if (!('stations' in value) || value['stations'] === undefined) return false;
    return true;
}

export function RequestAllExcelDownloadUrlFromJSON(json: any): RequestAllExcelDownloadUrl {
    return RequestAllExcelDownloadUrlFromJSONTyped(json, false);
}

export function RequestAllExcelDownloadUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestAllExcelDownloadUrl {
    if (json == null) {
        return json;
    }
    return {
        
        'stations': json['stations'],
        'part': json['part'] == null ? undefined : json['part'],
    };
}

export function RequestAllExcelDownloadUrlToJSON(json: any): RequestAllExcelDownloadUrl {
    return RequestAllExcelDownloadUrlToJSONTyped(json, false);
}

export function RequestAllExcelDownloadUrlToJSONTyped(value?: RequestAllExcelDownloadUrl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stations': value['stations'],
        'part': value['part'],
    };
}

